module.exports = __webpack_public_path__ + "images/paylocity_logo.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/images/paylocity_logo.jpg
// module id = 1194
// module chunks = 0